import React from "react";
import CustomTemplates from "../../Deals/CustomTemplate";
import { home } from "../../../../components/template/CustomTemplate/Pages/home";

const HomePage = () => {
  return (
    <CustomTemplates slug={"home"} attributes={home} />
  );
};

export default HomePage;
